module.exports = __webpack_public_path__ + "static/media/custumer3.89c36e12.jfif";